import {allowedCaseOptions} from "eslint-plugin-vue/lib/utils/casing";

export default {
    data(){
        return {
            serviceChannelsPopupData: null,
            search: "",
            isAvailableServices: false,
            propertyFilter: {
                pvr: false,
                periodicPvr: false,
                catchup: false,
                timeshift: false,
                advertisements: false,
                devices: false,
                profiles: false,
                vod: false,
                channels: false,
            }
        }
    },
    computed: {
        filteredServices() {
            const hasFilter = Object.values(this.propertyFilter).some(Boolean);
            const hasSearch = !!this.search.length;
            const normalizedSearch = hasSearch ? this.search.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase() : '';
            if(hasSearch || hasFilter || this.isAvailableServices){
                const result = [];
                let allowBySearch = true;
                let allowByFilter = true;
                this.services.forEach(service => {
                    let allowByArchive = true;
                    if(this.isAvailableServices && !service.assignable){
                        allowByArchive = false;
                    }

                   if(allowByArchive && hasSearch){
                       const normalizedName = service.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
                       allowBySearch = normalizedName.includes(normalizedSearch);
                   }

                   if(allowByArchive && allowBySearch && hasFilter){
                       let allowByPvr = true;
                       let allowByPeriodicPvr = true;
                       let allowByCatchup = true;
                       let allowByTimeshift = true;
                       let allowByAdvertisements = true;
                       let allowByDevices = true;
                       let allowByProfiles = true;
                       let allowByVod = true;
                       let allowByChannels = true;

                       // pvr
                       if(this.propertyFilter.pvr){
                           allowByPvr = (service.pvr !== null || service.pvr_disabled_by_service === true);
                       }

                       // periodic pvr
                       if(this.propertyFilter.periodicPvr){
                           allowByPeriodicPvr = (service.periodic_pvr !== null || service.periodic_pvr_disabled_by_service === true)
                       }

                       // catchup
                       if(this.propertyFilter.catchup){
                           allowByCatchup = (service.catchup !== null || service.catchup_disabled_by_service === true);
                       }

                       // timeshift
                       if(this.propertyFilter.timeshift){
                           allowByTimeshift = (service.timeshift !== null || service.timeshift_disabled_by_service === true)
                       }

                       // advertisement
                       if(this.propertyFilter.advertisements){
                           allowByAdvertisements = (service.allow_skip_multiple_advertisement_blocks
                               || service.allow_skip_multiple_advertisement_blocks_nonlinear
                               || service.is_skippable !== null
                               || service.is_skippable_nonlinear !== null
                               || service.time_with_no_advertisement_after_start_seconds !== null
                               || service.time_with_no_advertisement_after_start_seconds_nonlinear !== null
                               || service.autoskip);
                       }

                       // devices
                       if(this.propertyFilter.devices){
                           allowByDevices = service.device_count !== null;
                       }

                       // profiles
                       if(this.propertyFilter.profiles){
                           allowByProfiles = service.subscriber_profile_count !== null;
                       }

                       // vod
                       if(this.propertyFilter.vod){
                           allowByVod = !this._.isEmpty(service.vod) || service.vod_disabled_by_service === true
                       }

                       // channels
                       if(this.propertyFilter.channels){
                           allowByChannels = service.id_channels_including_from_channel_packages.length;
                       }

                       allowByFilter = allowByPvr
                           && allowByPeriodicPvr
                           && allowByCatchup
                           && allowByTimeshift
                           && allowByAdvertisements
                           && allowByDevices
                           && allowByProfiles
                           && allowByVod
                           && allowByChannels;
                   }

                   if(allowByFilter && allowBySearch && allowByArchive){
                       result.push(service);
                   }
                });

                return result;
            }else {
                return this.services;
            }
        },
    },
    methods: {
        getServiceData(service) {
            let result = {
                pvr_free_minutes: service.pvr ? service.pvr_free_minutes : null,
                pvr_lifetime_in_days: service.pvr ? service.pvr_lifetime_in_days : null,
                pvr_disabled_by_service: service.pvr_disabled_by_service,
                catchup_hours: service.catchup ? service.catchup_hours: null,
                catchup_disabled_by_service: service.catchup_disabled_by_service,
                timeshift: service.timeshift ? service.timeshift: null,
                timeshift_disabled_by_service: service.timeshift_disabled_by_service,
                device_count: service.device_count,
                device_addon: service.device_addon,
                subscriber_profile_count: service.subscriber_profile_count,
                subscriber_profile_addon: service.subscriber_profile_addon,
                time_with_no_advertisement_after_start_seconds: service.time_with_no_advertisement_after_start_seconds,
                time_with_no_advertisement_after_start_seconds_nonlinear: service.time_with_no_advertisement_after_start_seconds_nonlinear,
                skip_after_seconds: service.skip_after_seconds,
                skip_after_seconds_nonlinear: service.skip_after_seconds_nonlinear,
                allow_skip_multiple_advertisement_blocks: service.allow_skip_multiple_advertisement_blocks,
                allow_skip_multiple_advertisement_blocks_nonlinear: service.allow_skip_multiple_advertisement_blocks_nonlinear,
                periodic_pvr_count: service.periodic_pvr ? service.periodic_pvr_count : null,
                periodic_pvr_days_back: service.periodic_pvr ? service.periodic_pvr_days_back: null,
                periodic_pvr_disabled_by_service: service.periodic_pvr_disabled_by_service,
                periodic_pvr_addon: service.periodic_pvr_addon,
                channels: service.channels_summed,
                autoskip: service.autoskip,
                weight: null,
                vod: service.vod,
                vod_disabled_by_service: service.vod_disabled_by_service
            };
            if (service.hasOwnProperty('weight_value')) {
                result.weight = service.weight_value;
            }

            if (service.hasOwnProperty('channels_summed')) {
                result.channels = service.channels_summed;
            } else if (service.hasOwnProperty('id_channels_including_from_channel_packages')){
                result.channels = service.id_channels_including_from_channel_packages;
            }else{
                result.channels = [];
            }

            return result;
        },
        onServiceInfoClick(id){
            const url = this.$router.resolve({ name: 'serviceDetail', params: { id } }).href;
            window.open(url, '_blank');
        },
        loadServiceChannelsPopupData(channelsIds, summedChannelsData) {
            let data = []
            this._.forEach(this.allDeviceGroups, function (deviceGroup) {
                let serviceAllowedChannels = this.getServiceAllowedChannels(deviceGroup, channelsIds)
                this._.forEach(serviceAllowedChannels, function (allowedGroupChannel) {
                    this._.forEach(summedChannelsData, function (summedChannel) {
                        if (Number(allowedGroupChannel['id']) === Number(summedChannel['id'])) {
                            this._.assign(allowedGroupChannel, summedChannel)
                        }
                    }.bind(this))
                }.bind(this))

                data.push({
                    'id': deviceGroup['id'],
                    'name': deviceGroup['name'],
                    'channels': serviceAllowedChannels
                });
            }.bind(this))
            this.serviceChannelsPopupData = data
        },
        getServiceByServiceId(services, serviceId) {
            let service = this._.filter(services, function (assignedService) {
                return Number(serviceId) === Number(assignedService.id)
            })
            if (service) {
                return service[0]
            }
            return {}
        },
        getServiceAllowedChannels(deviceGroup, channelsIds) {
            let serviceAllowedChannelsIds = this.deviceGroupChannelsRestriction.hasOwnProperty(deviceGroup.id) ?
                this._.difference(
                channelsIds,
                this.deviceGroupChannelsRestriction[deviceGroup.id]
                )
                : channelsIds;
            return this._.filter(this.allChannels, function (channel) {
                return this._.includes(serviceAllowedChannelsIds, Number(channel['id']))
            }.bind(this))
        },
        isServiceActive(service){
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const parseDate = (dateStr) => {
                if (!dateStr) return null;
                const [day, month, year] = dateStr.split('.').map(s => s.trim());
                return new Date(`${year}-${month}-${day}`);
            };

            const validFrom = parseDate(service.valid_from);
            const validTo = parseDate(service.valid_to);

            const valid = (
                (!validFrom || validFrom <= today) &&
                (!validTo || today <= validTo)
            );

            return service.enabled != false && valid;
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/views/subscribers/mixins/subscriberService.js